
import ProductsPage from '~/components/ProductsPage'
export default {
  auth: false,
  components: {
    ProductsPage
  },
  head: {
    title: 'Productos',
    meta: [
      { hid: 'og:title', name: 'og:title', content: 'Productos' },
      { hid: 'description', name: 'description', content: 'Productos' }
    ]
  }
}
